<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"
import { percent } from "@/support"

const props = defineProps({
  categories: Array,
  fpData: Array,
  privateData: Array,
  privateRangeData: Array,
  publicData: Array,
  publicRangeData: Array,
  year1: Number,
  year2: Number,
})

onMounted(() => {
  new Highcharts.Chart({
    chart: { renderTo: "fp" },
    title: { text: "" },
    legend: { enabled: false },
    subtitle: { text: "Tuition Discounting" },
    tooltip: { shared: false, crosshairs: false, formatter() {
      return `${Math.round(this.y * 10) / 10}% paid full price`
    } },
    xAxis: {
      categories: props.categories,
      tickInterval: 1,
      labels: {
        rotation: -45,
        align: "right",
      },
    },
    yAxis: [
      {
        gridLineWidth: 1,
        title: { text: "", style: { color: "#4572A7" } },
        labels: {
          formatter() {
            return `${this.value}%`
          },
          style: { color: "#4572A7" },
        },
        opposite: false,
        endOnTick: true,
        min: 0,
        max: 100,
        tickInterval: 25,
      },
    ],
    series: [
      { name: "% Paying Full Price", type: "spline", color: "#3bc9db", yAxis: 0, data: props.fpData },
    ],

  })
  new Highcharts.Chart({
    chart: { renderTo: "netTuition" },
    title: { text: "Private Law School Net Tuition" },
    legend: { enabled: false },
    subtitle: { text: "Average Full Time Tuition" },
    tooltip: { shared: true, crosshairs: true },
    xAxis: {
      categories: props.categories,
      tickInterval: 1,
      labels: {
        rotation: -45, align: "right",
      },
    },
    yAxis: [
      {
        gridLineWidth: 1,
        title: { text: "Net Tuition", style: { color: "#4572A7" } },
        labels: {
          formatter() {
            return `${this.value / 1000}k`
          },
          style: { color: "#4572A7" },
        },
        opposite: false,
        endOnTick: true,
        min: 0,
        max: 60000,
      },
    ],
    series: [
      { name: "Private", type: "spline", color: "#21150F", yAxis: 0, data: props.privateData, dataLabels:
        {
          useHTML: true, enabled: true, style: { fontWeight: 500 }, x: 0, y: 5, borderRadius: 2,
          formatter() {
            const index = this.point.index
            let diff

            if (index) {
              const previous = this.series.data[index - 1]
              diff = percent(this.y - previous.y, previous.y)

              let s_color = ""

              if (diff > 0) {
                s_color = "color:green;"
                diff = `+${diff}`
              } else if (diff < 0) {
                s_color = "color:red;"
              }

              return `<span style='font-size:14px;${s_color}'>${diff}%</span>`
            }
          },
        } },
      {
        name: "Range",
        data: props.privateRangeData,
        type: "arearange",
        lineWidth: 0,
        linkedTo: ":previous",
        color: Highcharts.getOptions().colors[1],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false,
        },
      },
    ],

  })
  new Highcharts.Chart({
    chart: { renderTo: "netTuition2" },
    title: { text: "Public Law School Net Tuition" },
    subtitle: { text: "Average Full Time Resident Tuition" },
    legend: { enabled: false },
    tooltip: { shared: true, crosshairs: true },
    xAxis: {
      categories: props.categories,
      tickInterval: 1,
      labels: { rotation: -45, align: "right" },
    },
    yAxis: [
      {
        gridLineWidth: 1,
        title: { text: "Net Tuition", style: { color: "#4572A7" } },
        labels: {
          formatter() {
            return `${this.value / 1000}k`
          },
          style: { color: "#4572A7" },
        },
        opposite: false,
        endOnTick: true,
        min: 0,
        max: 60000,
      },
    ],
    series: [
      { name: "Public", type: "spline", color: "#4572A7", yAxis: 0, data: props.publicData, dataLabels:
        {
          useHTML: true, enabled: true, style: { fontWeight: 500 }, x: 0, y: 5, borderRadius: 2,
          formatter() {
            const index = this.point.index
            let diff

            if (index) {
              const previous = this.series.data[index - 1]
              diff = percent(this.y - previous.y, previous.y)

              let s_color = ""

              if (diff > 0) {
                s_color = "color:green;"
                diff = `+${diff}`
              } else if (diff < 0) {
                s_color = "color:red;"
              }

              return `<span style='font-size:14px;${s_color}'>${diff}%</span>`
            }
          },
        } },
      {
        name: "Range",
        data: props.publicRangeData,
        type: "arearange",
        lineWidth: 0,
        linkedTo: ":previous",
        color: Highcharts.getOptions().colors[0],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false,
        },
      },
    ],

  })
})
</script>
